import QueryParamsUtil from 'api/utils/query-params-util'
import axios from 'axios'

const API_PATH = 'api/v2/admins/merchants/inbounds/items/rejects'

const MerchantInboundItemRejectApiV2 = {
  /**
   * Get list of `Merchant Inbound Item Reject`
   * @param {object} params uri parameter
   * @return {object} Collection of `Merchant`
   */
  get: async ({ tableState, additionalFilters }) => {
    const params = QueryParamsUtil.format(tableState, additionalFilters)
    const path   = API_PATH

    const response = axios.get(path, { params })
    return response
  },

  /**
   * Destroy Inbound item reject and its dependent
   * reset curation total and inbound item qty
   */
  delete: async (id) => {
    const path = `${API_PATH}/${id}`

    const response = axios.delete(path)
    return response
  }
}

export default MerchantInboundItemRejectApiV2
